import * as PreviewDomainClient from 'ContentUtils/api/previewDomainClient';
import { getPreviewPages } from 'web-interactives-data/api/WebInteractives';
import { FETCH_PREVIEW_PAGES, FETCH_PREVIEW_DOMAIN_SUCCEEDED } from 'web-interactives-dashboard-ui/actions/ActionTypes';
import { getPreviewDomain } from 'web-interactives-dashboard-ui/selectors/preview';
export const fetchPreviewDomainSuccess = previewDomain => ({
  type: FETCH_PREVIEW_DOMAIN_SUCCEEDED,
  previewDomain
});
export const fetchPreviewDomain = () => (dispatch, getState) => {
  const state = getState();
  if (getPreviewDomain(state)) return;
  PreviewDomainClient.fetchPreviewDomain().then(previewDomain => {
    dispatch(fetchPreviewDomainSuccess(previewDomain));
  }).catch(() => {
    console.error('Failed to fetch preview domain');
  });
};
const fetchPreviewPagesStart = () => ({
  type: FETCH_PREVIEW_PAGES.STARTED
});
const fetchPreviewPagesSuccess = payload => ({
  type: FETCH_PREVIEW_PAGES.SUCCEEDED,
  payload
});
const fetchPreviewPagesError = error => ({
  type: FETCH_PREVIEW_PAGES.FAILED,
  error
});
export const fetchPreviewPages = contentId => dispatch => {
  dispatch(fetchPreviewPagesStart());
  getPreviewPages(contentId).then(response => {
    dispatch(fetchPreviewPagesSuccess(response));
  }).catch(error => {
    dispatch(fetchPreviewPagesError(error));
  });
};